import {
  COURIER_ACTIVITYLOGS_REQUEST,
  COURIER_ACTIVITYLOGS_SUCCESS,
  COURIER_ACTIVITYLOGS_FAILURE
} from '../../actions/courierActions'

export default function reducer(
  state = {
    loading: false,
    data: {
      count: 0,
      results: [],
      current_page: 1,
      num_pages: 1
    },
    error: null
  },
  action
) {
  switch (action.type) {
    case COURIER_ACTIVITYLOGS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null
      })
    case COURIER_ACTIVITYLOGS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data,
        error: null
      })
    case COURIER_ACTIVITYLOGS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      })
    default:
      return state
  }
}
